/**
 * Amount charged at application submit. Always $0, on every path.
 *
 * This is not a placeholder or a simplification — it is unconditionally
 * accurate. Nothing is charged at signup:
 *
 *  - The standard path takes no payment at all; the billing cycle starts only
 *    after the application is approved and the member borrows their first item.
 *  - The `AUTH_CHARGE_UTM_SOURCES` path *looks* like a counterexample, but the
 *    payment intent in `api/stripe/attach/payment_method` is created with
 *    `capture_method: 'manual'` — an authorization hold that is never
 *    captured. `AUTH_CHARGE_MIN_CENTS` ($1.50) exists only "to avoid banks
 *    blocking very low authorization amounts". That is card verification,
 *    not a payment.
 *
 * So: do not "fix" this to derive from the preview cart or the auth charge.
 * Unlike Monthly, Due Now is invariant — no membership selection changes it.
 */
export const DUE_NOW_DISPLAY = '$0';
